import DropDown from '../../DropDown';
import styles from './styles.module.scss';

import cn from 'classnames';

const ContextMenuBase = ({ close = () => { }, children, className, ...props }) => (
  <DropDown close={() => close()} styles={cn(styles.context_menu, className, props.styles)}>
    <div className={styles.content}>{children}</div>
  </DropDown>
);

export default ContextMenuBase;
